export default __webpack_public_path__ + "static/media/5.b3803198.png";